import { config } from '@/infrastructure/config'
import type { VacationsApi } from './api'
import type { AuthSession } from './auth'
import { createHttpApi } from './http-api'
import { createMockApi } from './mock-api'

export * from './api'
export { auth, DEMO_ACCOUNTS, type AuthSession, type AuthUser } from './auth'
export { resetMockData } from './mock-api'

/** Current session, kept in sync by the SessionProvider (used to sign API calls). */
let current: AuthSession | null = null
export function setCurrentSession(s: AuthSession | null) {
  current = s
}

export const api: VacationsApi = config.apiUrl
  ? createHttpApi(config.apiUrl, () => current?.accessToken ?? null)
  : createMockApi(() => current?.user ?? null)
